import axios from 'axios'
import store from '../store/store';

const customAxios = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {'X-Custom-Header': 'foobar'}

})

customAxios.interceptors.request.use(config => {
  if(store.state.Token)
    config.headers.Authorization = `Bearer ` + store.state.Token;
  
  return config;
})

export default customAxios;


